// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"transitionVairant_paragraph__3tNjW","highlight":"transitionVairant_highlight__2Yy3i","btn":"transitionVairant_btn__2N-xq"};